import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const BootstrapTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-input::placeholder": {
    fontSize: "0.9rem",
    fontWeight: 300,
    color: "#888",
    opacity: 1,
  },
  "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ff6c6c",
  },
  "& .MuiFormHelperText-root.Mui-error": {
    color: "#ff6c6c",
    marginLeft: 0,
  },
}));

export default BootstrapTextField;
